import React, { useEffect, useMemo, useState } from "react";
import styles from "../../PagesStyles/AdminPurchaseEntryNew.module.css";
import AdminHeading from "../Heading/AdminHeading";
import AlertMessage from "Components/Other Functions/AlertMessage";
import { ClipLoader } from "react-spinners";
import ErrorModal from "Components/Other Functions/popup";
import { useNavigate, useParams } from "react-router-dom";
import { toPlainFields } from "Components/support/Allfields/fieldconverter";
import {
  InvoiceEntryNewFields,
  QuotationEntryNewFields,
  OldGoldInvoiceEntryNewFields,
  PurchaseEntryFields,
  PurchaseEntryNewFields,
} from "Components/support/Allfields/purchasefields";
import { useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { RiAddBoxFill } from "react-icons/ri";
import { IoMdRefresh } from "react-icons/io";
import { GoTrash } from "react-icons/go";
import { Icon } from "@iconify/react";
import Summary from "Components/AdminPurchaseEntryNew/Summary";
import SkuForm from "Components/AdminPurchaseEntryNew/SkuForm";
import { useQuery } from "@tanstack/react-query";
import GetApiService from "Components/Api/getapiService";
import {
  calculateAmount,
  convertInInvoiceWholeSaleFormat,
  getAllPaymentMethod,
  getCurrentFinancialYear,
  getQuotationEditEntryFormData,
  getQuotationEntryFormData,
  goldCategoryIds,
  looseDiamondId,
  looseStoneId,
  selectStyle,
  silverCategoryIds,
} from "utils/helpers";
import toast from "react-hot-toast";
import PaymentModeForm from "Components/AdminPurchaseEntryNew/PaymentModeForm";
import PaymentModeFormQuotation from "Components/AdminPurchaseEntryNew/PaymentModeFormQuotation";
import Select from "react-select";
import StoneSummary from "Components/AdminPurchaseEntryNew/StoneSummary";
import DiamondSummary from "Components/AdminPurchaseEntryNew/DiamondSummary";
import PaymentsEntryTable from "Components/AdminPurchaseEntryNew/PaymentsEntryTable";
import PaymentsEntryTableQuotation from "Components/AdminPurchaseEntryNew/PaymentEntryTableQuotation";
import AmountSection from "Components/AdminPurchaseEntryNew/AmountSection";
import InvoiceSkuForm from "Components/AdminPurchaseEntryNew/InvoiceSkuForm";
import QuotationSkuForm from "Components/AdminPurchaseEntryNew/QuotationSkuForm";
import InvoiceWholeSaleSummary from "Components/AdminPurchaseEntryNew/InvoiceWholeSaleSummary";
import QuotationWholeSaleSummary from "Components/AdminPurchaseEntryNew/QuotationWholesaleSummary";
import AdminBreadCrump from "../Heading/AdminBreadCrump";
import { Check, Refresh } from "@mui/icons-material";
import Spinner from "Components/CommonComponents/Spinner";
import { a201, a710, a714, a717, a729, a731, j759, j761, j763 } from "Components/Api/RootApiPath";
import PageLoader from "Components/PageLoader";
import { fetchInvoiceList, fetchInvoiceNumber } from "services/invoiceServices";
import {fetchQuotationNumber} from 'services/quotationServices'
import { fetchCustomerTouncheList } from "services/Tounches";
import {
  generateBillInvocePDF,
  generateBillPDF,
} from "Components/Other Functions/GenerateBillPDF";
import { useAdminData } from "../AdminSettings/useAdminData";
import { fetchAllRates } from "services/rate";
import { GenerateQuotationPdf } from "Components/Other Functions/GenerateQuotationPdf";
import useScreenSize from "hooks/useScreenSize";
import AmountSectionQuotation from "Components/AdminPurchaseEntryNew/AmountSectionQuotation";

const purchaseProductDefault = {
  StockKeepingUnit: "",
  ItemCode: "",
  MakingFixedAmt: 0,
  MakingPerGram: 0,
  MakingFixedWastage: 0,
  MakingPercentage: 0,
  MetalRate: 0,
  FinePercent: 0,
  WastagePercent: 0,
  Quantity: 1,
  PurityId: 0,
  CategoryId: 0,
  ProductId: 0,
  DesignId: 0,
  FineGoldWt: 0,
  FineSilverWt: 0,
  TotalFineGold: "",
  FineOtherMetalWt: 0,
  TotalStoneAmt: 0,
  TotalItemAmt: 0,
  FineWt: 0,
  WastageWt: 0,
  FineWastageWt: 0,
  RDPurchaseId: 0,
  CategoryName: "",
  ProductName: "",
  DesignName: "",
  GrossWt: 0,
  NetWt: 0,
  StoneWt: 0,
  Status: "Active",
  CounterId: 0,
  BranchId: 0,
  CompanyId: 0,
  FinePure: false,
  ClientCode: 0,
  AddToUnlabelled: false,
  MetalId: 0,
  MetalName: "",
  StoneName: "",
  StoneWeight: 0,
  StonePieces: 0,
  StoneRate: 0,
  StoneAmount: 0,
  HallmarkAmt: 0,
  TagWeight: 0,
  FindingWeight: 0,
  LanyardWeight: 0,
  Testing: "0",
  Stones: [],
  Diamonds: [],
  ConvertAmount: true,
  MRP: "0",
  ClipWeight: "0",
  ClipQuantity: "0",
  DiamondName: "",
  DiamondWeight: 0,
  DiamondRate: 0,
  DiamondPieces: 0,
  DiamondAmount: 0,
  DiamondSize: "0",
  DiamondPurchaseRate: "0",
  DiamondSellRate: "0",
  DiamondClarity: "",
  DiamondColour: "",
  DiamondShape: "",
  DiamondCut: "",
  DiamondSettingType: "",
  DiamondCertificate: "",
  DiamondPurchaseAmount: "0",
  DiamondSellAmount: "0",
  DiamondDescription: "",
  status: "paid",
  skus: [],
  paymentTypes: [{ id: 1, mode: "Cash", amount: 1000, gold: 20, silver: 30 }],
  balanceGold: "",
  taxableAmount: "",
  gst: "",
  paidAmount: "",
  advanceAmount: "",
  balanceSilver: "",
  RODiscount: "",
  totalAmount: "",
  balanceAmount: "",
}; 

const QuotationNew = ({editStatus, defaultValues}) => {

   
  const date =  new Date().toISOString().split("T")[0];




 
  

  console.log(defaultValues);

  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false); // Modal visibility state
  const [errorMessage, setErrorMessage] = useState(null);
  const [active, setActive] = useState("AddNew");
  const [messageToShow, setMessageToShow] = useState("");
  const [messageType, setMessageType] = useState("");
  const [showError, setShowError] = useState(false);
  const [isSummaryOpen, setIsSummaryOpen] = useState();
  const [category, setCategory] = useState("");
  const [invoiceCreateLoading, setInvoiceCreateLoading] = useState(false);
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  const employeeFirstName = adminLoggedIn.FirstName;
  const employeeLastName = adminLoggedIn.LastName;
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const CompanyId = adminLoggedIn.CompanyId;
  const BranchId = adminLoggedIn.BranchId;
  const CounterId = adminLoggedIn.CounterId;
  const EmployeeId = adminLoggedIn.EmployeeId;
  const labelFormat = parseInt(adminLoggedIn.Clients.LabelFormat);
  const apiService = new GetApiService(clientCode);
  const InvoiceFormat = parseInt(adminLoggedIn?.Clients?.InvoiceFormat);

  const isSmallScreen = useScreenSize(); // Get screen size

 
  

  const fetchData = async () => {
    try {
      const data = await apiService.fetchInvoiceCustomers();
      return data;
    } catch (e) {
      console.log(e);
    }
  };
  const {
    data: customerList,
    isLoading,
    isError,
    refetch: RefetchCustomerList,
  } = useQuery({
    queryKey: ["getAllcustomerList"],
    queryFn: fetchData,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const { data: CustomerTounchList, refetch: customerListRefetch } = useQuery({
    queryKey: ["getCustomerTounchList", clientCode],
    queryFn: fetchCustomerTouncheList,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  // const {
  //   data: InvoiceList,
  //   isLoading: invoiceListIsLoading,
  //   refetch: InvoiceRefetch,
  // } = useQuery({
  //   queryKey: ["getInvoicesList", clientCode],
  //   queryFn: fetchInvoiceList,
  //   refetchOnWindowFocus: false,
  //   // cacheTime: 1000 * 60 * 2,
  //   // staleTime: 1000 * 60 * 2,
  // });
  const {
    data: QuotationNumber,
    isLoading: invoiceNumberIsLoading,
    refetch: QuotationNumberRefetch,
  } = useQuery({
    queryKey: ["Quotation/fetchQuotationNumber", clientCode],
    queryFn: fetchQuotationNumber,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });

  const { data: rateList } = useQuery({
    queryKey: ["rateList", clientCode],
    queryFn: fetchAllRates,
    refetchOnWindowFocus: false,
    // cacheTime: 1000 * 60 * 2,
    // staleTime: 1000 * 60 * 2,
  });
  const apifields = useMemo(
    () =>
      adminLoggedIn.Modules.filter(
        (module) => module.PageName === "invoice_entry"
      ),
    [adminLoggedIn]
  );
  const localfields = useMemo(() => toPlainFields(QuotationEntryNewFields), []);
  const oldGoldLocalfields = useMemo(
    () => toPlainFields(OldGoldInvoiceEntryNewFields),
    []
  );
  const apifieldsControls = useMemo(
    () => apifields[0]?.PageControls || [],
    [apifields]
  );

  const [itemfields, setItemfields] = useState(() =>
    localfields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) => apiField.key === localField.key
      );
      if (matchingApiField) {
        return {
          ...localField,
          label: matchingApiField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: matchingApiField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
        };
      }
      return localField;
    })
  );

  const [oldGoldItems, setOldGoldItems] = useState(() =>
    oldGoldLocalfields.map((localField) => {
      const matchingApiField = apifieldsControls.find(
        (apiField) => apiField.key === localField.key
      );
      if (matchingApiField) {
        return {
          ...localField,
          label: matchingApiField.label,
          placeholder: matchingApiField.placeholder,
          priority: matchingApiField.priority,
          type: matchingApiField.type,
          visibility: matchingApiField.visibility,
          place: matchingApiField.place,
        };
      }
      return localField;
    })
  );

  const [purchaseProduct, setPurchaseProduct] = useState(
    purchaseProductDefault
  );
  const [editValues, setEditValues] = useState();
  const [edit, setEdit] = useState(false);

  

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
  });

  const specificField = watch("StockKeepingUnit");
  const skus = watch("skus");
  const paymentTypes = watch("paymentTypes");
  const inputPaymentMode = watch("inputPaymentMode");
  const quotationNumber = watch("quotationNumber");
  const TotalFineMetal = watch("TotalFineMetal");
  const gstCheckbox = watch("gstCheckbox");
  const additionalTaxCheckbox = watch("additionalTaxCheckbox");
  const CourierCharge = watch("CourierCharge");
  const customerName = watch("customerName");
  const TotalBillAmount = watch("TotalBillAmount");
  const TotalTaxableAmount = watch("TotalTaxableAmount");
  const TotalRODiscount = watch("TotalRODiscount");
  const AdvanceAmount = watch("advanceamount");
  const TotalPaidAmount = watch("TotalPaidAmount");

  useEffect(() => {
    // if (editStatus) {
    setIsSummaryOpen(true);
    // }
  }, [editStatus]);
  // useEffect(() => {
  //   if (invoiceNumber) {
  //     setValue("gstCheckbox", true);
  //   } else {
  //     setValue("gstCheckbox", false);
  //   }
  // }, [invoiceNumber]);

  console.log(quotationNumber);
  console.log(QuotationNumber);
  
  

  useEffect(() => {
    if (!editStatus && QuotationNumber) {
      setValue("gstCheckbox", true);
      
    }
  }, [QuotationNumber]);


  //persist quotation number when edit
  useEffect(() => {
    if (editStatus && QuotationNumber) {
      setValue("quotationNumber", QuotationNumber.LastQuotationTrue);
      
    }
  }, [QuotationNumber]);



  useEffect(() => {
    if (TotalTaxableAmount > 5000000) {
      setValue("additionalTaxCheckbox", true);
    }
  }, [TotalTaxableAmount]);
  

  useEffect(() => {
    let financialYear = getCurrentFinancialYear();
    if (!editStatus && QuotationNumber) {
      // const list = gstCheckbox
      //   ? InvoiceList?.filter((item) => item?.BillType == "true")
      //   : InvoiceList?.filter((item) => item?.BillType == "false");
      if (QuotationNumber) {
        // let listItem = list[list.length - 1];
        // let num = `${+listItem?.InvoiceCount + 1}/${financialYear}`;
        let num = QuotationNumber?.LastQuotationTrue?.split("/")[0];
        console.log(num);
        if (gstCheckbox) {
          let latest = +(num || 0) + 1;
          setValue("quotationNumber", `${latest}/${financialYear}`);
        } else {
          setValue(
            "quotationNumber",
            `${+(QuotationNumber?.LastQuotationFalse || 0) + 1}`
          );
        }
      } else {
        setValue("quotationNumber", `1/${financialYear}`);
      }
    }
    if (!editStatus && !QuotationNumber) {
      setValue("quotationNumber", `1/${financialYear}`);
    }
  }, [QuotationNumber, gstCheckbox]);

  useEffect(() => {
    // if(TotalRODiscount){

    if (gstCheckbox && TotalTaxableAmount) {
      setValue(
        "TotalBillAmount",
        (
          +TotalTaxableAmount * 0.03 +
          +TotalTaxableAmount -
          +TotalRODiscount
        )?.toFixed(3)
      );
      setValue("TotalGst", (+TotalTaxableAmount * 0.03)?.toFixed(3));
    } else {
      setValue(
        "TotalBillAmount",
        ((+TotalTaxableAmount || 0) - (+TotalRODiscount || 0))?.toFixed(3)
      );
      setValue("TotalGst", "");
    }

    if (
      additionalTaxCheckbox &&
      TotalTaxableAmount &&
      +(TotalTaxableAmount || 0) > 5000000
    ) {
      setValue(
        "TotalBillAmount",
        (
          (gstCheckbox ? +TotalTaxableAmount * 0.03 : 0) +
          +TotalTaxableAmount * 0.001 +
          +TotalTaxableAmount -
          +TotalRODiscount +
          +(CourierCharge || 0)
        )?.toFixed(3)
      );
      setValue("additionalTax", (+TotalTaxableAmount * 0.001)?.toFixed(3));
    } else {
      setValue(
        "TotalBillAmount",
        (
          (gstCheckbox ? +TotalTaxableAmount * 0.03 : 0) +
          +TotalTaxableAmount -
          +TotalRODiscount +
          +(CourierCharge || 0)
        )?.toFixed(3)
      );
      setValue("additionalTax", "");
    }
    // }
  }, [
    TotalTaxableAmount,
    gstCheckbox,
    additionalTaxCheckbox,
    TotalRODiscount,
    CourierCharge,
    skus,
  ]);

  console.log(skus);
  console.log(defaultValues);
  
  

  useEffect(() => {
    let paidMetal = 0;
    let advanceAmount = 0;
    let balanceMetal = 0;
    let paidAmount = 0;

    paymentTypes?.forEach((item) => {
      if (
        (item?.status == "paid" || item?.status == "received") &&
        item?.mode == "Metal"
      ) {
        paidMetal += +item?.MetalFinePaid || 0;
      }
      if (item?.status == "advance") {
        advanceAmount += +(item?.amount || 0);
      }
      if (
        (item?.status == "paid" || item?.status == "received") &&
        (item?.mode == "Cash" ||
          item?.mode == "Metal to Cash" ||
          item?.mode == "Card" ||
          item?.mode == "UPI" ||
          item?.mode == "Cheque" ||
          item?.mode == "RTGS")
      ) {
        paidAmount += +(
          +(item?.amount || 0) ||
          +(item?.MetalCashTotalAmount || 0) ||
          0
        );
        // if (item?.MetalCashTotalAmount) {
        //   setValue(
        //     "TotalTaxableAmount",
        //     (
        //       +(TotalTaxableAmount || 0) - +(item?.MetalCashTotalAmount || 0)
        //     )?.toFixed(3)
        //   );
        // }
      }
      if (
        (item?.status == "received" || item?.status == "paid") &&
        item?.mode == "Cash to Metal"
      ) {
        paidMetal += +(item?.MetalFinePaid || 0);
      }
    });

    if (+TotalFineMetal) {
      balanceMetal = +(TotalFineMetal || 0) - +(paidMetal || 0);
    } else {
      balanceMetal = 0 - +(paidMetal || 0);
    }

    setValue("TotalPaidMetal", (+(paidMetal || 0))?.toFixed(3));
    setValue("TotalBalanceMetal", (+(balanceMetal || 0))?.toFixed(3));
    setValue("TotalAdvanceAmount", (+(advanceAmount || 0))?.toFixed(3));
    setValue("TotalPaidAmount", (+(paidAmount || 0))?.toFixed(3));
  }, [paymentTypes, TotalFineMetal]);

  useEffect(() => {
    setValue(
      "TotalBalanceAmount",
      (+(TotalBillAmount || 0) - +(TotalPaidAmount || 0))?.toFixed(3)
    );
  }, [TotalBillAmount, TotalPaidAmount]);

  // useEffect(()=>{
  // if(CourierCharge){
  //   setValue("TotalBillAmount",(+(TotalBillAmount || 0) + +(CourierCharge || 0)))
  // }else{
  //   setValue("TotalBillAmount",(+(TotalBillAmount || 0)))
  // }
  // },[CourierCharge])

  useEffect(() => {
    RefetchCustomerList();
  }, [customerName?.value]);

  useEffect(() => {
    const customer = customerList?.length
      ? customerList?.find((customr) => customr?.Id == customerName?.value)
      : {};
    if (customer?.Id) {
      setValue("TotalFineGold", customer?.FineGold);
      setValue("Mobile", customer?.Mobile);
      setValue("advanceamount", customer?.AdvanceAmount);
      setValue("balanceamount", customer?.BalanceAmount);
    }
  }, [customerName?.value, customerList]);

  // useEffect(()=>{
  //     if(tdsCheckbox)
  // },[tdsCheckbox,s])

  const reloadData = () => {
    setShowModal(false); // Close the modal
    // loadData();
  };

  const addSku = (data, fromDropdown) => {
    console.log(data);
    if (!customerName?.value) {
      toast.error("Please Select Customer", {
        position: "top-center",
        duration: 3000,
      });
      return;
    }
    let result = [];
    let customerTounch = [];
    if (fromDropdown) {
      result = CustomerTounchList?.filter((item) => {
        if (
          item?.CustomerId == customerName?.value &&
          item?.StockKeepingUnit == data?.SKU &&
          item?.CategoryId == data?.CategoryId &&
          item?.ProductId == data?.ProductId &&
          item?.DesignId == data?.DesignId &&
          item?.PurityId == data?.PurityId
        ) {
          return item;
        }
      });
    }
    if (fromDropdown) {
      customerTounch = CustomerTounchList?.filter((item) => {
        if (item?.CustomerId == customerName?.value) {
          return item;
        }
      });
    }

    const res = fromDropdown
      ? rateList?.length &&
        rateList?.filter((item) => {
          if (
            item?.PurityId == data?.PurityId &&
            item?.CategoryId == data?.CategoryId
          ) {
            return item;
          }
        })?.length
        ? {
            ...data,
            MetalRate: +(
              rateList?.filter(
                (item) =>
                  item?.PurityId == data?.PurityId &&
                  item?.CategoryId == data?.CategoryId
              )[0]?.Rate || 0
            ),
            MakingPercentage: result?.length
              ? result[0]?.MakingPercentage
              : data?.MakingPercentage,
            FinePercent: result?.length
              ? result[0]?.FinePercentage
              : data?.FinePercentage,
            MakingFixedAmt: result?.length
              ? result[0]?.MakingFixedAmt
              : data?.MakingFixedAmt,
            MakingPerGram: result?.length
              ? result[0]?.MakingPerGram
              : data?.MakingPerGram,
            MakingFixedWastage: result?.length
              ? result[0]?.MakingFixedWastage
              : data?.MakingFixedWastage,
          }
        : {
            ...data,
            MakingPercentage: result?.length
              ? result[0]?.MakingPercentage
              : data?.MakingPercentage,
            FinePercent: result?.length
              ? result[0]?.FinePercentage
              : data?.FinePercentage,
            MakingFixedAmt: result?.length
              ? result[0]?.MakingFixedAmt
              : data?.MakingFixedAmt,
            MakingPerGram: result?.length
              ? result[0]?.MakingPerGram
              : data?.MakingPerGram,
            MakingFixedWastage: result?.length
              ? result[0]?.MakingFixedWastage
              : data?.MakingFixedWastage,
          }
      : convertInInvoiceWholeSaleFormat(data);

    const sku = fromDropdown ? calculateAmount(res, customerTounch) : res;
    console.log(sku);
    setValue("skus", [...skus, sku]);
    setIsSummaryOpen(true);
  };

  const updateSku = (data) => {
    const res = convertInInvoiceWholeSaleFormat(data);
    setValue(
      "skus",
      skus.map((sku, index) => (index == res.index ? res : sku)) // Replace only the matching SKU
    );
    setEditValues();
    setEdit(false);
    setIsSummaryOpen(true);
  };
  const addPaymentMode = (data) => {
    setValue("paymentTypes", [
      ...paymentTypes,
      {
        // id: editStatus ? data?.id : Date.now(),
        ...data,
      },
    ]);
  };

  const onSubmit = async (data) => {
    // if (!skus.length) {
    //   toast.error("Atleast one item needed");
    //   return;
    // }

    console.log(data)

    const formData = editStatus
      ? getQuotationEditEntryFormData({
          data,
          customerList,
          clientCode,
           quotationDate,
          CompanyId,
          CounterId,
          BranchId,
          EmployeeId,
          employeeFirstName,
          employeeLastName,
        })
      : getQuotationEntryFormData({
          data,
          customerList,
          clientCode,
          quotationDate,
          CompanyId,
          CounterId,
          BranchId,
          EmployeeId,
          employeeFirstName,
          employeeLastName,
        });


        console.log(formData);
        

    if (+(formData?.TotalFineMetal || 0) && gstCheckbox) {
      toast.error("In metal quotation GST is not applicable", {
        position: "top-center",
        duration: 3000,
      });
      return;
    }



    setInvoiceCreateLoading(true);


  
    

    if (editStatus) {
      try {
        const response = await fetch(j763, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });

        console.log(response);
        
        const jsondata = await response.json();

        console.log(jsondata);
        
          const quotationById = await fetch(j761, {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({ id: jsondata?.Id, clientCode }),
           });


        if (jsondata?.Status == 400) {
          throw new Error("Failed to update quotation");
        } else {
          toast.success(`Quotation has been updated successfully.`);
          const quotation = await quotationById?.json();

          console.log(quotation);
          

          GenerateQuotationPdf(
            quotation?.QuotationItem,
            quotation?.Customer,
            InvoiceFormat,
            quotation,
            adminLoggedIn,
            isSmallScreen
          );
          navigate("/quotation_list");
        }
      } catch (error) {
        toast.error(error?.message || "Failed to update invoice information.");
      } finally {
        setInvoiceCreateLoading(false);
      }
    } else {
      try {
      

           

  

        const response = await fetch(j759, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        });
        const rcvdData = await response.json();

        const data = await updateCustomerDetail(formData);

        if (rcvdData?.Status == 400) {
          throw new Error("Failed to create quotation");
        } else {
          toast.success(
            `Invoice has been ${
              editStatus ? "updated" : "created"
            } successfully.`
          );

          GenerateQuotationPdf(
            rcvdData?.QuotationItem,
            rcvdData?.Customer,
            InvoiceFormat,
            rcvdData,
            adminLoggedIn,
            isSmallScreen
          );

          if (editStatus) {
            navigate("/invoice_entries_list");
          } else {
            QuotationNumberRefetch();
            customerListRefetch();
            setTimeout(() => {
              navigate("/quotation_entry_new");
            }, 2000);
          }
        }
      } catch (error) {
        console.log(error);
        toast.error(`${error?.message || "Failed to create invoice"}`);
      } finally {
        setInvoiceCreateLoading(false);
      }
    }
  };

  async function updateCustomerDetail(formData) {
    const currentCategory = formData?.QuotationItem[0]?.CategoryId;
    let FineGold = 0;
    let FineSilver = 0;
    if (goldCategoryIds.includes(+(currentCategory || 0))) {
      // FineGold += data?.
      FineGold += +(formData?.TotalBalanceMetal || 0);
    }
    if (silverCategoryIds.includes(+(currentCategory || 0))) {
      // FineGold += data?.
      FineSilver += +(formData?.TotalBalanceMetal || 0);
    }

    const customer = customerList?.find(
      (cstmr) => cstmr?.Id == formData?.CustomerId
    );

    const customerData = {
      ...customer,
      BalanceAmount:
        "" +
        (
          +(customer?.BalanceAmount || 0) + +(formData?.BalanceAmount || 0)
        )?.toFixed(3),
      AdvanceAmount:
        "" +
        (
          +(customer?.AdvanceAmount || 0) + +(formData?.TotalAdvanceAmount || 0)
        )?.toFixed(3),
      ...(goldCategoryIds.includes(+(currentCategory || 0))
        ? { FineGold: "" + (+(customer?.FineGold || 0) + FineGold)?.toFixed(3) }
        : {}),
      ...(silverCategoryIds.includes(+(currentCategory || 0))
        ? {
            FineSilver:
              "" + (+(customer?.FineSilver || 0) + FineSilver)?.toFixed(3),
          }
        : {}),
    };

    try {
      const updateCustomerDetail = await fetch(a710, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(customerData),
      });
    } catch (error) {
      console.log(error);
    }
  }

  const handleReset = () => {
    if (editStatus && id) {
      navigate(`/edit_invoice_entry_new/${id}`);
    } else {
      // RDPurchaseRefetch();
      navigate("/quotation_entry_new");
    }
  };

  console.log(itemfields);
  

  return (
    <>
      <div>
        <AdminHeading />
        {/* {invoiceCreateLoading ? (
          // Show spinner while loading
          <div className="spinner-container">
            <PageLoader />
          </div>
        ) : ( */}
        <>
          <div>
            <ErrorModal
              isOpen={showModal}
              onRequestClose={() => {
                setShowModal(false); // Close the modal
                navigate("/adminhome"); // Redirect to /adminhome
              }}
              onReload={reloadData} // Pass reload function
              message={errorMessage}
            />

            <div className="adminMainBodyBox">
              {showError ? (
                <AlertMessage message={messageToShow} type={messageType} />
              ) : null}
            </div>
          </div>
        </>
        {/* )} */}

        {isSmallScreen ? (
          ""
        ) : (
          <AdminBreadCrump
            title={`${
              editStatus ? "Quotation" : "Quotation"
            }`}
            companyName={"Loyalstring"}
            module={"Transactions"}
            page={`${
              editStatus ? "Quotation" : "Quotation"
            }`}
          />
        )}
      </div>

      <form className={styles.mainbox}>
        {/*basic detail section */}
        <div className={styles.linesection} style={{ padding: "0px 20px" }}>
          <div className={styles.infoline}>
            <div
              className={styles.box}
              style={{ display: "flex", alignItems: "center", gap: "6px" }}
            >
              <label>Quotation No: </label>
              {invoiceNumberIsLoading ? (
                <Spinner />
              ) : (
                <strong style={{ color: "blue", fontSize: "14px" }}>
                  {quotationNumber}
                </strong>
                // <input {...register("invoiceNumber")}
                // disabled={true}
                // />
              )}

              {/*  */}
            </div>

            <div className={styles.dateSection}>
              
              <div
                style={{
                  display: "flex",
                  alignItems: "start",
                  gap: "5px",
                  flexDirection: "column",
                  height: '35px'
                }}
              >
                <label htmlFor="quotationDate">Date</label>
                <div style={{ position: "relative", display: "inline-block" }}>
                  <input
                    id="quotationDate"
                    type="date"
                    {...register("quotationDate")}
                    style={{
                      width: "100%",
                      padding: "5px 10px",
                      paddingRight: "30px",
                      borderRadius: "4px",
                      border: "1px solid #ccc",
                      appearance: "none",
                      WebkitAppearance: "none",
                      MozAppearance: "none",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* top section */}


        <div className={styles.linesection}>
          <div className={styles.container}>
            {itemfields
              ?.filter((field) => field?.place === "top" && field.IsVisible)
              .sort((a, b) => a.priority - b.priority)
              .map((field, index) => (
                <div className={styles.box}>
                  <label>
                    {field.label}
                    {field?.mandatory && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                  </label>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "2px",
                    }}
                  >
                    <div style={{ flex: "6" }}>
                      {field.type === "inputselect" ? (
                        <input
                          type="text"
                          name={field.key}
                          
                          placeholder={`${field.label}`}
                          disabled={field.visibility === "ReadOnly"}
                          {...register(field.key, {
                            required:
                              field?.mandatory &&
                              field.visibility !== "ReadOnly" &&
                              `${field.label} is required`,
                          })}
                          list="skuList"
                          autoComplete="off"
                          style={{
                            border: "1px solid #ddd",
                            position: "relative",
                            width: "100%",
                           
                          }}
                        />
                      ) : // SKU Input with datalist

                      field.type === "dropdown" ||
                        field.type === "searchDropdown" ? (
                        <Controller
                          name={field.key}
                          control={control}
                          rules={{
                            required:
                              field?.mandatory &&
                              field.visibility !== "ReadOnly" &&
                              `${field.label} is required`,
                          }}
                          render={({
                            field: controllerField,
                            // fieldState: { error },
                          }) => (
                            <Select
                              {...controllerField}
                              options={
                                field.key === "customerName"
                                  ? Array.isArray(customerList)
                                    ? customerList?.map((vendor) => ({
                                        value: vendor?.Id,
                                        label: vendor?.FirstName,
                                        //  + vendor?.LastName
                                      }))
                                    : []
                                  : []
                              }
                              isDisabled={field.visibility === "ReadOnly"}
                              isSearchable={field.type === "searchDropdown"}
                              placeholder="-- select --"
                              styles={selectStyle}
                            />
                          )}
                        />
                      ) : field.type === "number" || field.type === "text" ? (
                        // Number input field
                        <input
                          name={field.key}
                          type={field.type}
                          placeholder={`${field.label}`}
                          {...register(field.key, {
                            required:
                              field.visibility !== "ReadOnly" &&
                              field?.mandatory &&
                              `${field.label} is required`,
                            pattern:
                              field.type === "number" ? /^\d+$/ : undefined,
                          })}
                          style={{ border: "1px solid #ddd", height: '35px', width: '100%' }}
                          disabled={field.visibility === "ReadOnly"}
                        />
                      ) : null}
                    </div>
                    {field?.key == "customerName" && (
                      <button
                        title="Add Customer"
                        type="button"
                        onClick={() => navigate("/add_customer_new")}
                        style={{ background: "#627282", flex: "1" }}
                      >
                        +
                      </button>
                    )}
                  </div>
                  {errors[field.key] && (
                    <span className={styles.fielderror}>
                      {errors[field.key].message}
                    </span>
                  )}
                </div>
              ))}
          </div>
        </div>
        
        {isSummaryOpen ? (
          <div className={styles.summarySection}>
            <>
              {skus[0]?.CategoryId?.value != looseStoneId &&
              skus[0]?.CategoryId?.value != looseDiamondId ? (
                <QuotationWholeSaleSummary
                  skus={skus}
                  setIsSummaryOpen={setIsSummaryOpen}
                  setValue={setValue}
                  setEditValues={setEditValues}
                  setEdit={setEdit}
                  addSku={addSku}
                  TotalFineMetal={TotalFineMetal}
                />
              ) : skus?.length && skus[0]?.CategoryId?.value == looseStoneId ? (
                <StoneSummary
                  skus={skus}
                  setIsSummaryOpen={setIsSummaryOpen}
                  setValue={setValue}
                  setEditValues={setEditValues}
                  setEdit={setEdit}
                  TotalFineMetal={TotalFineMetal}
                />
              ) : skus?.length &&
                skus[0]?.CategoryId?.value == looseDiamondId ? (
                <DiamondSummary
                  skus={skus}
                  setIsSummaryOpen={setIsSummaryOpen}
                  setValue={setValue}
                  setEditValues={setEditValues}
                  setEdit={setEdit}
                  TotalFineMetal={TotalFineMetal}
                />
              ) : (
                ""
              )}
            </>
          </div>
        ) : (
          <>
            {/* middle section */}

            <QuotationSkuForm
              isInvoiceEntry={true}
              itemfields={itemfields}
              oldGoldLocalfields={oldGoldLocalfields}
              editValues={editValues}
              edit={edit}
              updateSku={updateSku}
              addSku={addSku}
              isSummaryOpen={isSummaryOpen}
              setIsSummaryOpen={setIsSummaryOpen}
              skus={skus}
              apifields={apifields}
              setItemfields={setItemfields}
              setCategory={setCategory}
              customerName={customerName}
              CustomerTounchList={CustomerTounchList}
              gstCheckbox={gstCheckbox}
              rateList={rateList}
            />
          </>
        )}

        {/* bottom section */}
        <div className={styles.linesection}>
          {/* calculations section */}
          <div className={styles.calculation}>
            {/* Left Section */}

            {isSmallScreen ? (
              <>
                <AmountSection
                  styles={styles}
                  register={register}
                  invoice={true}
                />
                <div className={styles.calculationleft}>
                  <PaymentModeFormQuotation
                    // addPaymentMode={addPaymentMode}
                    // invoiceNumber={quotationNumber}
                    // AdvanceAmount={AdvanceAmount}
                    // editStatus={editStatus}
                    // componentType={"Invoice"}
                    // gstCheckbox={gstCheckbox}
                    // skus={skus}
                  />

                  <div className={styles.tableContainer}>
                    <PaymentsEntryTableQuotation
                      styles={styles}
                      paymentTypes={paymentTypes}
                      setValue={setValue}
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className={styles.calculationleft}>
                  <PaymentModeFormQuotation
                    // addPaymentMode={addPaymentMode}
                    // invoiceNumber={invoiceNumber}
                    // AdvanceAmount={AdvanceAmount}
                    // editStatus={editStatus}
                    // componentType={"Invoice"}
                    // gstCheckbox={gstCheckbox}
                    // skus={skus}
                  />

                  <div className={styles.tableContainer}>
                    <PaymentsEntryTableQuotation
                      styles={styles}
                      paymentTypes={paymentTypes}
                      setValue={setValue}
                    />
                  </div>
                </div>

                {/* Right Section */}
                <AmountSectionQuotation
                  styles={styles}
                  register={register}
                  invoice={true}
                />
              </>
            )}
          </div>
          {/* {errors.status && (
            <p className={styles.error}>{errors.status.message}</p>
          )} */}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            width: "100%",
            gap: "10px",
          }}
        >
          <button
            style={{
              fontSize: "12px", // Smaller font size for responsiveness
              backgroundColor: "#0077d4",
              padding: "4px 6px", // Adjusted padding
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flex: "1 1 auto", // Allows buttons to shrink proportionally
              minWidth: "100px", // Minimum button width
              maxWidth: "150px", // Prevents overly wide buttons
            }}
            type="button"
            onClick={handleSubmit(onSubmit)}
            disabled={invoiceCreateLoading}
          >
            {invoiceCreateLoading ? <Spinner /> : <Check size={20} />}{" "}
            {/* Adjusted icon size */}
            Save
          </button>

          <button
            type="button"
            onClick={handleReset}
            style={{
              background: "#fff",
              fontSize: "12px", // Smaller font size for responsiveness
              color: "#0077D4",
              padding: "4px 6px", // Adjusted padding
              display: "flex",
              alignItems: "center",
              gap: "5px",
              border: "1px solid #0077D4",
              flex: "1 1 auto",
              minWidth: "100px",
              maxWidth: "150px",
            }}
            disabled={invoiceCreateLoading}
          >
            <Refresh size={20} /> {/* Adjusted icon size */}
            Reset
          </button>

          <button
            onClick={() => {
              navigate(`/quotation_list`);
            }}
            type="button"
            style={{
              fontSize: "12px", 
              backgroundColor: "#0077d4",
              padding: "4px 6px",
              display: "flex",
              alignItems: "center",
              gap: "5px",
              flex: "1 1 auto",
              minWidth: "100px",
              maxWidth: "150px",
            }}
            disabled={invoiceCreateLoading}
          >
            <Icon style={{ fontSize: "20px" }} icon="solar:list-bold" />{" "}
       
            Quotation List
          </button>
        </div>
      </form>
    </>
  );
};

export default QuotationNew;
